import { differenceInCalendarDays } from 'date-fns';
import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { BubbleContainer } from '@xing-com/crate-upsell-discount-bubble';
import { BodyCopy } from '@xing-com/typography';

interface CountdownBubbleProps {
  endDate: Date;
}

export const chunkInSpan = (chunks: ReactNode[]): ReactNode => (
  <Span>{chunks}</Span>
);

export function CountdownBubble({
  endDate,
}: CountdownBubbleProps): JSX.Element {
  const today = new Date();
  const remainingDays = differenceInCalendarDays(endDate, today);

  return (
    <BubbleContainer data-testid="countdown-bubble">
      <BodyCopy
        size="xsmall"
        sizeConfined="xsmall"
        sizeWide="small"
        lineHeight="dense"
        noMargin
        style={{ textAlign: 'center' }}
      >
        <FormattedMessage
          id="UPSELL_PURCHASE_COUNTDOWN_BUBBLE_MESSAGE"
          values={{
            span: chunkInSpan,
            remainingDays,
          }}
        />
      </BodyCopy>
    </BubbleContainer>
  );
}

const Span = styled.span`
  display: block;
`;
